let meta = document.querySelector('meta[property="fb:app_id"]')
meta.content = process.env.VUE_APP_FB_APP_ID
